import { Box, Button, Grid, IconButton } from "@mui/material";
import CustomInput from "../components/ui/CustomInput";
import PageHeader from "../components/ui/PageHeader";
import PageForm from "../components/ui/PageForm";
import CustomGridHeaderCell from "../components/ui/CustomGridHeaderCell";
import { useRef, useState, useEffect } from "react";
import CustomTable from "../components/ui/CustomTable";
import axios from "../api/axiosClient";
import CustomTablePagingInfo from "../components/ui/CustomTablePagingInfo";
import { useIntl } from "react-intl";
import { useLoading } from "../components/LoadingContext";
import { useSelector } from "react-redux";
import {
  handleError,
  errorToast,
  useKeyDown,
  addDownloadLinkToDocument,
} from "../services/serviceBase";
import toast from "react-hot-toast";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import EditDestinationTriangModal from "../components/Modals/CreditNote/EditDestinationTriangModal";
import ShowExistingDestinationsModal from "../components/Modals/CreditNote/ShowExistingDestinationsModal";

const CreditNoteDestinationTriang = () => {
  const intl = useIntl();
  const { setLoading } = useLoading();
  const idCompany = useSelector((state) => state.common.company);

  const [code, setCode] = useState(null);
  const [description, setDescription] = useState(null);

  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 10;
  const fileRef = useRef(null);

  const [shouldFilterCollapse, setShouldFilterCollapse] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setColumns] = useState([]);
  const [existingNotCNDestinations, setExistingNotCNDestinations] = useState([]);
  const [tableHeigth, setTableHeigth] = useState(260);
  const [editData, setEditData] = useState(null);

  //#region Edit destination modal
  const [openModalEditDestination, setOpenModalEditDestination] =
    useState(false);
  const handleOpenModalEditDestination = () =>
    setOpenModalEditDestination(true);
  const handleCloseModalEditDestination = () => {
    setOpenModalEditDestination(false);
    handleSearch();
  };
  //#endregion

  //#region ShowExistingDestinationsModal
  const [openModalShowExistingDestinations, setOpenModalShowExistingDestinations] =
    useState(false);
  const handleOpenModalShowExistingDestinations = () =>
    setOpenModalShowExistingDestinations(true);
  const handleCloseModalShowExistingDestinations = () => {
    setOpenModalShowExistingDestinations(false);
    setExistingNotCNDestinations([]);
    handleSearch();
  };
  //#endregion

  const handleEditData = (data) => {
    setEditData({
      code: data.jdaLocation,
      description: data.description,
      idJdaLocationDestination: data.idJDALocationDestination,
      idJdaLocation: data.idJDALocation,
    });
  };

  useEffect(() => {
    if (editData !== null) {
      handleOpenModalEditDestination();
    }
  }, [editData]);

  useKeyDown(() => {
    handleSearch();
  }, ["Enter"]);

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var headerHeight = document.querySelector("#header").clientHeight;
    var pagingInfoHeight = document.querySelector("#pagingInfo").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight = pageHeight - fromHeight - headerHeight - pagingInfoHeight - 90;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  useEffect(() => {
    getColumns();
  }, [rows, page, tableHeigth]);

   useEffect(() => {
    if (existingNotCNDestinations.length > 0) {
      handleOpenModalShowExistingDestinations();
    }
  }, [existingNotCNDestinations]);

  const handleDelete = (idJDALocationDestination) => {
    var message = intl.formatMessage({ id: "General.ConfirmAction" });
    if (!window.confirm(message)) {
      return false;
    }
    setLoading(true);
    axios
      .delete("/creditnote/destinationtriang/" + idJDALocationDestination)
      .then((response) => {
        setLoading(false);
        toast.success("Deleted!");
        handleSearch();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleUpload = async () => {
    setLoading(true);

    const data = new FormData();
    data.append("file", fileRef.current.files[0]);
    var url = "/creditnote/destinationtriang/upload";
    axios
      .post(url, data)
      .then((response) => {
        toast.success("Saved");
        handleSearch();
        setLoading(false);
        setExistingNotCNDestinations(response.data);
        fileRef.current.value = null;
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleSearch = () => {
    setShouldFilterCollapse(false);
    setLoading(true);
    const params = new URLSearchParams([]);
    if (code !== undefined && code !== "") {
      params.append("Code", code);
    }
    if (
      description !== undefined &&
      description !== ""
    ) {
      params.append("Description", description);
    }

    params.append("IdCompany", idCompany);
    params.append("PagingInfo.Skip", `${rowsForPage * page.current}`);
    params.append("PagingInfo.Take", `${rowsForPage}`);
    axios
      .get("/creditnote/destinationtriang", { params })
      .then((response) => {
        setShouldFilterCollapse(true);
        setLoading(false);
        resizeTable();


        setRows(response.data.paginatedItems);
        setTotalCount(response.data.totalCount);
        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
        //page.current = 1;
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, () => {
          errorToast(error, intl);
        });
      });
  };

  const getColumns = () => {
    setColumns([
      {
        field: "jdaLocation",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "NdCDestinationTriang.Code" })}
          />
        ),
        flex: 1,
        minWidth: 250,
      },
      {
        field: "description",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({
              id: "NdCDestinationTriang.Description",
            })}
          />
        ),
        flex: 1,
        minWidth: 90,
      },
      {
        field: "actionDelete",
        type: "actionDelete",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.Delete" })}
          />
        ),
        minWidth: 90,
        resizable: false,
        renderCell: (params) => {
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(e) => handleDelete(params.row.idJDALocationDestination)}
            >
              <DeleteIcon />
            </IconButton>
          );
        },
      },
      {
        field: "actionEdit",
        type: "actionEdit",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.Edit" })}
          />
        ),
        minWidth: 90,
        resizable: false,
        renderCell: (params) => {
          return (
            <IconButton
              aria-label="go"
              size="large"
              color="primary"
              onClick={(e) => {
                handleEditData(params.row);
              }}
            >
              <EditIcon />
            </IconButton>
          );
        },
      },
    ]);
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearch();
    }
  };

  const handlePreviousPage = () => {
    page.current = page.current - 1;
    handleSearch();
    // if (page.current > 1) {
    //   page.current = page.current - 1;
    //   handleSearch();
    // }
  };

  const handletrasitionEnd = () => {
    resizeTable();
  };

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PageHeader
        title={intl.formatMessage({ id: "NdCDestinationTriang.Title" })}
      />
      <PageForm
        adjustHeightFunc={handletrasitionEnd}
        shouldCollapse={shouldFilterCollapse}
        form={
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "NdCDestinationTriang.Code",
                      })}
                      type="text"
                      value={code}
                      setValue={setCode}
                      textCol={2}
                      inputCol={10}
                    />
                  </Grid>
                  <Grid item md={6}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "NdCDestinationTriang.Description",
                      })}
                      type="text"
                      value={description}
                      setValue={setDescription}
                      textCol={2}
                      inputCol={10}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item md={2} display="flex" justifyContent="flex-start">
                <CustomInput
                  type="file"
                  valueRef={fileRef}
                  acceptedContentTypes="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />
              </Grid>
              <Grid item md={2} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleUpload}
                >
                  {intl.formatMessage({ id: "General.Upload" })}
                </Button>
              </Grid>
              <Grid item md={6}></Grid>
              <Grid item md={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleSearch}
                >
                  {intl.formatMessage({ id: "General.Search" })}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <CustomTablePagingInfo
        totalCount={totalCount}
        page={page.current}
        maxPage={maxPage.current}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
      />
      <CustomTable
        columns={columns}
        rows={rows}
        id={"idJDALocationDestination"}
        rowHeight={70}
        headerHeight={80}
        tableHeight={tableHeigth}
      />

      {editData !== null ? (
        <EditDestinationTriangModal
          openModal={openModalEditDestination}
          handleCloseModal={handleCloseModalEditDestination}
          editData={editData}
        />
      ) : (
        ""
      )}

      {existingNotCNDestinations.length > 0 ? (
        <ShowExistingDestinationsModal
          openModal={openModalShowExistingDestinations}
          handleCloseModal={handleCloseModalShowExistingDestinations}
          data={existingNotCNDestinations}
        />
      ) : (
        ""
      )}
    </Box>
  );
};

export default CreditNoteDestinationTriang;
